import { render } from "./LearningProgressCircle.vue?vue&type=template&id=79a670b0"
import script from "./LearningProgressCircle.vue?vue&type=script&lang=js"
export * from "./LearningProgressCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__